// This should be used in cases where it is more desired to render nothing
// rather than rendering a message when an error boundary is hit.
const PassThrough = () => {
    return null;
};
export default PassThrough;
//# sourceMappingURL=PassThrough.js.map